var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wt-toggle',{staticClass:"transcribe-subtitles-toggle",on:{"toggle":_vm.$_onClick},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})}
var staticRenderFns = []

export { render, staticRenderFns }